var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lvmama_goods_nav" },
    [
      _vm.goodsList && _vm.goodsList.length > 0
        ? [
            _c(
              "div",
              { staticClass: "tabs" },
              [
                _c(
                  "el-tabs",
                  {
                    on: { "tab-click": _vm.tabChange },
                    model: {
                      value: _vm.activeTab,
                      callback: function ($$v) {
                        _vm.activeTab = $$v
                      },
                      expression: "activeTab",
                    },
                  },
                  _vm._l(_vm.tabList, function (item) {
                    return _c("el-tab-pane", {
                      key: item.id,
                      attrs: { label: item.name, name: item.id },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _vm.value.config.extend_sort === 1
              ? _c(
                  "div",
                  { staticClass: "navbar" },
                  _vm._l(_vm.navbarList, function (nav, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        class: [
                          "nav-item",
                          index === _vm.activeNav && "current",
                        ],
                      },
                      [
                        _vm._v(" " + _vm._s(nav.label) + " "),
                        nav.icon
                          ? _c("i", { class: ["el-icon", nav.icon] })
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "goods-list" },
              _vm._l(_vm.goodsList, function (item, index) {
                return _c("div", { key: index, staticClass: "goods-item" }, [
                  _c("div", {
                    staticClass: "image-wrapper",
                    style: { backgroundImage: "url(" + item.goods_thumb + ")" },
                  }),
                  _c("div", { staticClass: "item-right" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v(" " + _vm._s(item.goods_name) + " "),
                    ]),
                    _c("div", { staticClass: "middle" }, [
                      item.place_to_addr
                        ? _c("div", { staticClass: "address" }, [
                            _vm._v(" " + _vm._s(item.place_to_addr) + " "),
                          ])
                        : _vm._e(),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "bottom",
                        staticStyle: { "align-items": "flex-end" },
                      },
                      [
                        item.rating !== "0.0"
                          ? _c("div", { staticClass: "score" }, [
                              _c("div", { staticClass: "content" }, [
                                _c("span", [_vm._v(_vm._s(item.rating))]),
                                _c("span", { staticClass: "text" }, [
                                  _vm._v("分"),
                                ]),
                              ]),
                              Number(item.commentNumber) !== 0
                                ? _c("div", { staticClass: "evaluate" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(item.commentNumber) +
                                        "条评价 "
                                    ),
                                  ])
                                : _vm._e(),
                            ])
                          : _c("div"),
                        _c("div", { staticClass: "price" }, [
                          item.underlined_price
                            ? _c("span", { staticClass: "underlined-price" }, [
                                _vm._v(
                                  " " + _vm._s(item.underlined_price) + "点 "
                                ),
                              ])
                            : _vm._e(),
                          _c("span", { staticClass: "text" }, [
                            _vm._v(_vm._s(item.min_price)),
                          ]),
                          _vm._v(" 点起 "),
                        ]),
                      ]
                    ),
                  ]),
                ])
              }),
              0
            ),
          ]
        : _c("empty", { attrs: { value: _vm.value } }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }